import { APICore } from './apiCore'

const api = new APICore()

function getTravels (params) {
  const baseUrl = '/travels'
  return api.get(baseUrl, params)
}

function getTravel (id) {
  const baseUrl = `/travels/${id}`
  return api.get(baseUrl, {})
}

function addTravel (params) {
  const baseUrl = '/travels'
  return api.createWithFile(baseUrl, params)
}

function updateTravel (params) {
  const baseUrl = '/travels'
  return api.updateWithFile(baseUrl, params)
}

function deleteTravel (params) {
  const baseUrl = '/travels'
  return api.delete(baseUrl, params)
}

export { getTravels, getTravel, addTravel, updateTravel, deleteTravel }
